<!-- subscribe footer for news release -->
<div class="subs-footer py-md-2 py-3" *ngIf="link == 'news-and-events'">
    <div class="container">
        <div class="row">
            <div class="col-md-11 mx-auto">
                <app-subscribe [versi]="'2'"></app-subscribe>
            </div>
        </div>
    </div>
</div>
<!-- main footer -->
<div class="main-footer text-center" [ngClass]="{'main-footer-2': dataFooter?.next_menu}"> 
    <div class="container h-100 position-relative" *ngIf="!dataFooter?.next_menu">
        <div class="row h-100 align-items-center">
            <div class="col-sm-12 col-10 ml-sm-0 ml-auto">
                <p class="mb-0 reserved">© 2026 PT Prime Agri Resources Tbk | All Rights Reserved</p>
            </div>
        </div>
        <div class="up-scroll">
            <img height="26"
                 width="26" 
                 class="arr-up" 
                 src="../../../assets/images/icon/arrow-up.svg" alt="">
            <p class="up">{{ isLang?.up }}</p>
        </div>
    </div>
    <!-- next page footer -->
    <div class="container h-100 position-relative next-page" *ngIf="dataFooter?.next_menu">
        <div class="row justify-content-between">
            <div class="col-md-2 col-3">
                <div class="up-scroll">
                    <img height="26"
                        width="26" 
                        class="arr-up" 
                        src="../../../assets/images/icon/arrow-up.svg" alt="">
                    <p class="up mb-0">{{ isLang?.up }}</p>
                </div>
            </div>
            <div class="col-xl-6 col-md-7 col-9 py-3 text-right">
                <a class="d-inline-block" 
                    [routerLink]="dataFooter?.next_menu.link"
                    *ngIf="!dataFooter?.next_menu.parent">
                    <div class="next">
                        <p class="mb-2">{{ isLang?.next }}</p> {{ dataFooter?.next_menu.title }} 
                    </div>
                    <img class="ic-arright" src="../../../assets/images/icon/arrow-right-wbig.svg" alt="">
                </a>
                <a class="d-inline-block" 
                    [routerLink]="dataFooter?.next_menu.parent.link+'/'+dataFooter?.next_menu.link"
                    *ngIf="dataFooter?.next_menu.parent">
                    <div class="next">
                        <p class="mb-2">{{ isLang?.next }}</p> {{ dataFooter?.next_menu.title }} 
                    </div>
                    <img class="ic-arright" src="../../../assets/images/icon/arrow-right-wbig.svg" alt="">
                </a>
            </div>
        </div>
    </div>
</div>
